<div *ngIf="profile" style="margin-top: 4px">
    <div class="user-panel">
        <div class="user-info">
            <div class="image-container">
                <div class="user-image" style="padding-top: 6px;">
                    <i class="dx-icon-user" style="font-size: 16px;"></i>
                </div>
            </div>
            <div class="user-name">{{ profile?.email }}</div>
        </div>
        <dx-context-menu
            *ngIf="menuMode === 'context'"
            [items]="menuItems"
            target=".user-button"
            showEvent="dxclick"
            width="170px"
            [position]="{ my: 'center', at: 'right bottom' }"
            cssClass="user-menu"
        >
        </dx-context-menu>
        <dx-list *ngIf="menuMode === 'list'" class="dx-toolbar-menu-action" [items]="menuItems"> </dx-list>
    </div>
</div>
